<template>
  <div class="col-12">
    <template v-if="comments">
      <table id="commentTable" class="table table-hover">
        <tr v-if="comments.data.length>0">
          <th>
            کتاب
          </th>
          <th>
            دیدگاه
          </th>
        </tr>
        <template v-if="comments.data.length>0">
          
        <template v-for="(item, index) in comments.data">
          <tr :key="index">
            <td>{{ item.book.title }}</td>
            <td>{{ item.comment }}</td>
          </tr>
        </template>
        </template>
        <template v-else>
          <div id="noComment">
            دیدگاهی توسط شما ثبت نشده است
          </div>
            
        
        </template>
      </table>

      <div id="bookPagination" class="d-flex justify-content-center">
        <pagination
          v-if="comments != null"
          :data="comments"
          @pagination-change-page="changePage"
          :disabled="status"
        ></pagination>
      </div>
    </template>
    <Loader v-else />
  </div>
</template>
<script>
import mixin from "../mixins/mixins";
import Loader from "../components/loader.vue";
export default {
  mixins: [mixin],
  components: { Loader },
  data() {
    return {
      comments: null
    };
  },
  mounted() {
    this.$axios.get("/user/comments").then((res) => {
      this.comments = res.data.data.comments;
    });
     document.getElementById("Content").scrollIntoView({behavior:'smooth',block:'start'})

  },
  watch: {
    "$route.query.page": {
      handler(newVal) {
        this.$axios.get(`/user/comments?page=${newVal}`).then((res) => {
          this.comments = res.data.data.comments;
        });
        document
          .getElementById("commentTable")
          .scrollIntoView({ behavior: "smooth" });
      }
    }
  } ,  metaInfo() {
    return {
      title: "کامنت های شما",
      meta: [
        {
          name: "description",
          content:
            "کامنت های گذاشته شده کاربر در وبسایت میرداماد"
        },
        {
          property: "og:title",
          content:"کامنت های شما"
        },
        { name: "robots", content: "index,follow" }
      ]
    };
  }
};
</script>
<style scoped>
#commentTable {
  width: 90%;
  margin: auto;
}
</style>
<style>
.page-item.active .page-link {
  z-index: 1;
  color: #fd5 !important;
  background-color: #333333 !important;
  border-color: #ffdd55 !important;
}
#noComment{
    text-align: center;
    font-size: 27px;
    padding: 50px 0;
}
</style>
